<template>
  <card
    shadow
    type="secondary"
    class="answer-editor-card mt-4"
    :no-body="isEmpty"
  >
    <!-- CARD HEADER -->
    <template slot="header">
      <div class="row align-middle">
        <div class="col-9">
          <h4 class="mb-0">
            {{ $t(`${i18nPrefix}.title`) }}
          </h4>
        </div>
        <div class="col-3 text-right">
          <base-button
            type="primary"
            outline
            size="sm"
            v-if="isEmpty"
            @click="onSetup"
          >
            {{ $t(`${i18nPrefix}.setup`) }}
          </base-button>
          <base-button type="danger" outline size="sm" v-else @click="onDelete">
            <font-awesome-icon :icon="['fal', 'trash']" />
            {{ $t(`${i18nPrefix}.delete`) }}
          </base-button>
        </div>
      </div>
    </template>
    <div class="card-body" v-if="!isEmpty">
      <h4>{{ $t(`${i18nPrefix}.subtitle`) }}</h4>
      <TriggerAttributeCondition
        v-for="(el, idx) in payload"
        :key="el.key"
        :condition="el"
        :source="action.payload.source"
        :forbidden-keys="payloadKeys"
        @change="onChange(idx, $event)"
        @remove="onRemove(idx)"
      />
      <small
        :class="['add-condition-cta', { disabled: !isValidPayload }]"
        @click="onAddNewField"
        >{{ $t(`${i18nPrefix}.add`) }}</small
      >
    </div>
    <div class="card-body text-right py-0" v-if="!isEmpty">
      <base-button
        type="primary"
        size="sm"
        :disabled="!isValidPayload"
        @click="onSave"
      >
        <font-awesome-icon
          v-if="loading.save"
          :icon="['far', 'spinner']"
          spin
          class="mr-1"
        />
        {{ $t(`${i18nPrefix}.save`) }}
      </base-button>
    </div>
  </card>
</template>
<script>
import { mapState } from 'vuex';
import TriggerAttributeCondition from './TriggerAttributeCondition.vue';

export default {
  name: 'trigger-editor',
  components: { TriggerAttributeCondition },
  props: {
    action: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    i18nPrefix:
      'knowledge.diagnostic-builder.side-bar.triggers.salesforce.case-update',
    isEmpty: true,
    payload: [],
    loading: {
      save: false,
    },
  }),
  mounted() {
    this.processAction();
  },
  computed: {
    isValidPayload() {
      return this.payload
        .map(({ key, value }) => key && key !== 'md_new_condition' && value)
        .every((el) => el);
    },
    payloadKeys() {
      return this.payload.map(({ key }) => key);
    },
    ...mapState(['companyAttributes']),
  },
  methods: {
    processAction() {
      if (
        !this.action ||
        !this.action.id ||
        !this.action.payload ||
        !this.action.payload.attributes
      ) {
        this.isEmpty = true;
        return;
      }
      this.payload = [...this.action.payload.attributes];
      this.isEmpty = false;
      this.loading.save = false;
    },
    parseAttributLabel(attribute) {
      if (!attribute) return '';
      let { source, label } = attribute;
      source = source.charAt(0).toUpperCase() + source.slice(1);
      return `${source} - ${label}`;
    },
    onSetup() {
      this.$emit('create', {
        id: 'salesforce.caseUpdate',
        payload: {
          attributes: [{ key: 'md_new_condition', value: null }],
          source: 'salesforce',
          companyAttributes: true,
        },
      });
    },
    onChange(idx, el) {
      const newPayload = [...this.payload];
      newPayload[idx] = el;
      this.payload = newPayload;
    },
    onAddNewField() {
      if (!this.isValidPayload) return;
      this.payload = [
        ...this.payload,
        { key: 'md_new_condition', value: null },
      ];
    },
    onRemove(idx) {
      this.payload.splice(idx, 1);
    },
    onSave() {
      this.loading.save = true;
      this.$emit('change', {
        id: this.action.id,
        payload: {
          ...this.action.payload,
          attributes: this.payload,
        },
      });
      setTimeout(() => {
        this.loading.save = false;
      }, 3000);
    },
    onDelete() {
      this.$emit('delete', this.action.id);
    },
  },
  watch: {
    action() {
      this.processAction();
    },
  },
};
</script>
<style lang="scss" scoped>
.add-condition-cta {
  color: $grey-6-mayday;
  cursor: pointer;
  &:hover {
    color: $blue-mayday;
  }
}

.disabled {
  &:hover {
    color: $grey-6-mayday;
    cursor: not-allowed;
  }
}
</style>
